import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

// Цвет по имени — у каждого человека/компании свой, но стабильный
const PALETTE = [
  'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
  'bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300',
  'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300',
  'bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300',
  'bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300',
  'bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300',
];

export function initials(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

export function Avatar({ name, src, size = 'md', className }) {
  const hash = [...String(name || '')].reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  const sizes = { sm: 'h-7 w-7 text-[11px]', md: 'h-9 w-9 text-xs', lg: 'h-12 w-12 text-sm' };
  // Картинка не загрузилась (файл удалён) — показываем инициалы
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [src]);
  if (src && !broken) {
    return <img src={src} alt={name} onError={() => setBroken(true)} loading="lazy" className={clsx('shrink-0 rounded-full object-cover', sizes[size], className)} />;
  }
  return (
    <span className={clsx('inline-flex shrink-0 items-center justify-center rounded-full font-semibold', sizes[size], PALETTE[hash % PALETTE.length], className)}>
      {initials(name)}
    </span>
  );
}
